<template>
  <MountingPortal
    :mountTo="target"
    :append="append"
    :transition="transition"
  >
    <slot />
  </MountingPortal>
</template>

<script>
  import { MountingPortal } from 'portal-vue';

  export default {
    name: 'VuePortal',
    components: {
      MountingPortal
    },
    props: {
      target: {
        type: String,
        required: true,
      },
      append: [String, Boolean],
      transition: [String, Object],
    }
  }
</script>